import { render, staticRenderFns } from "./keywords_monitoring.vue?vue&type=template&id=cb55cbc8&scoped=true"
import script from "./keywords_monitoring.vue?vue&type=script&lang=js"
export * from "./keywords_monitoring.vue?vue&type=script&lang=js"
import style0 from "./keywords_monitoring.vue?vue&type=style&index=0&id=cb55cbc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb55cbc8",
  null
  
)

export default component.exports